import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DSIcon } from '../../../base';

import styles from './ListingChipsList.module.scss';

const ListingChipsList = ({ chipList = [], className = '' }) => {
  const items = chipList
    .filter(tag => !tag.hideInExperiment && tag.icon)
    .sort((a, b) => !!b.value - !!a.value || (a.order ?? 0) - (b.order ?? 0));

  return (
    <ul className={classNames(styles['listing-chips-list'], className)}>
      {items.map(tag => {
        const ChipWrapper = tag.onClick ? 'button' : 'span';
        return (
          <li
            key={tag.label || tag.name}
            className={styles['listing-chips-list__item']}
          >
            <ChipWrapper
              type={tag.onClick ? 'button' : undefined}
              className={classNames(styles['listing-chips-list__chip'], {
                [styles['listing-chips-list__chip--clickable']]: tag.onClick
              })}
              onClick={tag.onClick}
            >
              <DSIcon name={tag.icon} />
              <span
                className={classNames(
                  styles['listing-chips-list__chip-label'],
                  {
                    [styles['listing-chips-list__chip-label--clickable']]:
                      tag.onClick
                  }
                )}
              >
                {tag.name}
              </span>
            </ChipWrapper>
            {tag.subtext && (
              <span className={styles['listing-chips-list__subtext']}>
                {tag.subtext}
              </span>
            )}
          </li>
        );
      })}
    </ul>
  );
};

ListingChipsList.propTypes = {
  chipList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      icon: PropTypes.string,
      value: PropTypes.bool,
      order: PropTypes.number,
      hideInExperiment: PropTypes.bool,
      onClick: PropTypes.func,
      subtext: PropTypes.string
    })
  ),
  className: PropTypes.string
};

export default ListingChipsList;
